// This file is auto-generated by @hey-api/openapi-ts

export const OAuthProviderEnum = {
    GOOGLE: 'google',
    FACEBOOK: 'facebook',
    APPLE: 'apple'
} as const;

export type OAuthProviderEnum = typeof OAuthProviderEnum[keyof typeof OAuthProviderEnum];
